import { Album } from '../types';

export interface MetaTagData {
  title: string;
  description: string;
  image: string;
  url: string;
}

export const updateMetaTags = (data: MetaTagData) => {
  const { title, description, image, url } = data;
  
  // Debug logging
  console.log('Updating meta tags:', { title, description, image, url });
  
  // Update document title
  document.title = title;
  
  // Update basic meta tags
  updateMetaTag('description', description);
  
  // Update Open Graph tags
  updateMetaTag('og:title', title, 'property');
  updateMetaTag('og:description', description, 'property');
  updateMetaTag('og:image', image, 'property');
  updateMetaTag('og:url', url, 'property');
  updateMetaTag('og:image:width', '1024', 'property');
  updateMetaTag('og:image:height', '1024', 'property');
  updateMetaTag('og:image:type', 'image/png', 'property');
  
  // Update Twitter Card tags
  updateMetaTag('twitter:title', title, 'property');
  updateMetaTag('twitter:description', description, 'property');
  updateMetaTag('twitter:image', image, 'property');
  updateMetaTag('twitter:url', url, 'property');
  updateMetaTag('twitter:image:alt', 'FiestAlbum Live View', 'property');
  
  // Update additional meta tags
  updateMetaTag('image', image);
  updateMetaTag('twitter:image:src', image, 'name');
  
  // Update Discord-specific meta tags
  updateMetaTag('og:image:secure_url', image, 'property');
  updateMetaTag('twitter:image:width', '1024', 'name');
  updateMetaTag('twitter:image:height', '1024', 'name');
  
  // Additional Discord workarounds
  updateMetaTag('og:image:url', image, 'property');
  updateMetaTag('og:image:alt', 'FiestAlbum Live View', 'property');
};

const updateMetaTag = (name: string, content: string, attribute: string = 'name') => {
  let meta = document.querySelector(`meta[${attribute}="${name}"]`) as HTMLMetaElement;
  
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attribute, name);
    document.head.appendChild(meta);
  }
  
  meta.setAttribute('content', content);
};

export const generateEventMetaData = (album: Album): MetaTagData => {
  const eventName = album.eventName;
  const mediaCount = album.media.length;
  const firstImage = album.media.find(item => item.type === 'image');
  
  // Generate title
  const title = `${eventName} - FiestAlbum Live View`;
  
  // Generate description
  const description = `View and share photos from ${eventName}. ${mediaCount} ${mediaCount === 1 ? 'photo' : 'photos'} shared so far. Join the live album!`;
  
  // Use first image as preview, or fallback to a default
  const image = firstImage?.url || `${window.location.origin}/social-preview.png`;
  
  // Current URL
  const url = window.location.href;
  
  return {
    title,
    description,
    image,
    url
  };
};

export const setDefaultMetaTags = () => {
  const defaultData: MetaTagData = {
    title: 'FiestAlbum Live View',
    description: 'Share and view photos from your event in real-time. Create live albums that everyone can contribute to and enjoy together.',
    image: `${window.location.origin}/social-preview.png`,
    url: window.location.origin
  };
  
  updateMetaTags(defaultData);
};
